<div class="d-inline-flex">
  <div class="" *ngFor="let ctag of filtertagList">
    <button (click)="removeTag(ctag)" style="margin-top:2px;" matTooltip="{{ 'tagfilter.clickremove' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" class="btn rounded float-left mt-2 pt-1 ml-2 pl-2 pr-2 pb-1" >
      <p class="btn-text mb-0 ">{{ctag.title}}           
    </p>
   <!--- <span (click)="removeTag(ctag)"
    class="material-icons align-middle f-15 lh-25 center p-0 align-middle">
    close
  </span>--->
    </button>
  </div>
  <div class="align-right">
    <div class="dropleft">
      <button id="dropdownMenuButton" data-toggle="dropdown" (click)="toggleTags()" class="btn-empty mt-1 border-0">
        <span *ngIf="!label" class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
          filter_alt
            </span>
            <span *ngIf="label" class="material-icons lh-35 w-35 h-35 align-middle cursor-pointer ">
              label
              </span>
    </button>
      <div class="dropdown-menu " style="width:250px;" aria-labelledby="dropdownMenuButton">
        <!-- <a class="dropdown-item p-1">  <div class="input-group">
          <input type="text" class="form-control" placeholder="Your tag..." aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="filtertext">
          <div class="input-group-append h-35" (click)="createTag(filtertext)">
            <button class="btn bw" type="button"><p class="btn-text">Create</p></button>
          </div>
        </div></a> -->
        <a *ngFor="let tag of taglist | appFilter: filtertext" (click)="addTag(tag)" class="dropdown-item" ><p  class="mb-0 " appHighlight [searchedWord]="filtertext" [content]="tag.title"  
          [classToApply]="'font-weight-bold'" [setTitle]="'true'" >          
          </p></a>
        <a  *ngIf="taglist.length == 0" class="dropdown-item"><p  class="mb-0 " appHighlight [searchedWord]="filtertext" content="{{ 'tagfilter.loadingtags' | trans }}"  
          [classToApply]="'font-weight-bold'" [setTitle]="'true'" >   </a>
      </div>
    </div>
  </div>
</div>






<!-- 
  <button (click)="toggleTags()" class="btn-empty border-0">
      <span class="material-icons rounded-circle w-35 h-35 lh-35 align-middle btn portal-icon p-0 mr-2 center cursor-pointer">
          label
          </span>
  </button> -->
  <!-- <div *ngIf="showTags">
      <button *ngFor="let ctag of filtertagList" class="btn pt-1 pl-2 pr-2 pb-1">
          <p class="btn-text mb-0 ">{{ctag.title}}           
            <span (click)="removeTag(ctag)"
            class="material-icons align-middle f-15 lh-35 center p-0 align-middle">
            close
          </span>
        </p>
        </button>
  <div class="input-group mb-3">
      <input type="text" class="form-control" placeholder="Your tag..." aria-label="Recipient's username" aria-describedby="basic-addon2" [(ngModel)]="filtertext">
      <div class="input-group-append h-35" (click)="createTag(filtertext)">
        <button class="btn btn-outline-secondary" type="button"><p class="btn-text">Create</p></button>
      </div>
    </div>
  <ul class="dropdown">
      <li *ngFor="let tag of taglist | appFilter: filtertext" class="dropdown-item" (click)="addTag(tag)">
          <p  class="mb-0 " appHighlight [searchedWord]="filtertext" [content]="tag.title"  
          [classToApply]="'font-weight-bold'" [setTitle]="'true'" >          
          </p>
      </li>
  </ul>


  </div> -->